import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

const { borderRadius, colors, spacing, typography } = themeVariables;

/* The photo area's shape, from the design: a portrait crop rather than a square, so a
   photo of a person wearing something is not cut off at the shoulders. The theme has no
   aspect ratio scale, so the one value the design states is stated here. */
const PHOTO_ASPECT_RATIO = '1 / 1.15';

export const photos = css`
  position: relative;
`;

/* The scroll container and the list are the same element, so there is no wrapper between
   the track and the slides. `overscroll-behavior-x: contain` stops a swipe that reaches
   the last photo from being handed to the panel behind it, which on iOS is a back
   gesture. Same track as `ProductCarousel`. */
export const track = css`
  display: flex;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden;
  overscroll-behavior-x: contain;
  scroll-snap-type: x mandatory;
  list-style: none;
  border-radius: var(${borderRadius.md.mobile});

  /* The scrollbar is the panel's business, not the carousel's: the arrows and the counter
     are what say there is more. */
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const slide = css`
  flex: 0 0 100%;
  min-width: 0;
  scroll-snap-align: start;
`;

export const photo = css`
  display: block;
  width: 100%;
  aspect-ratio: ${PHOTO_ASPECT_RATIO};
  background-color: var(${colors.surface.disabled});
  object-fit: cover;
`;

const control = css`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`;

export const previousControl = css`
  ${control}
  left: var(${spacing.sm});
`;

export const nextControl = css`
  ${control}
  right: var(${spacing.sm});
`;

export const counter = css`
  margin: var(${spacing.xs}) 0 0;
  font-family: var(${typography.body.fontFamily});
  font-size: var(${typography.body.sizes.sm.fontSize});
  line-height: var(${typography.body.sizes.sm.lineHeight});
  letter-spacing: var(${typography.body.letterSpacing});
  color: var(${colors.content.secondary});
  text-align: center;
`;
